import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function parameterValueTypeValidator(parameterType: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    switch (parameterType) {
      case 1: // Number
        if (value.trim() === '') {
          return { invalidNumber: true };
        }
        if (!/^-?\d+$/.test(value)) {
          return { invalidNumber: true };
        }
        break;

      case 4: // Float
        if (value.trim() === '') {
          return { invalidFloat: true };
        }
        if (isNaN(Number(value))) {
          return { invalidFloat: true };
        }
        break;

      case 2: // Boolean
        if (value.trim() === '') {
          return { invalidBoolean: true };
        }
        if (!/^(true|false)$/i.test(value)) {
          return { invalidBoolean: true };
        }
        break;

      case 3: // DateTime
        if (value.trim() === '') {
          return { invalidDateTime: true };
        }
        if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
          return { invalidDateTime: true };
        }
        break;

      case 0: // String
      default:
        break;
    }

    return null;
  };
}

export function getParameterTypeErrorMessage(control: AbstractControl): string {
  if (control.hasError('invalidNumber')) {
    return 'Wrong type, expecting a whole number';
  }
  if (control.hasError('invalidFloat')) {
    return 'Wrong type, expecting a decimal number';
  }
  if (control.hasError('invalidBoolean')) {
    return 'Wrong type, expecting a boolean (true/false)';
  }
  if (control.hasError('invalidDateTime')) {
    return 'Wrong format, expecting YYYY-MM-DD';
  }
  return '';
}
